import React from 'react'
import * as Styled from './LogoColumn.styles'
import LogoImage from '../../assets/logo-vodovod-rijeka.png'

import l10n from '../../localization'

function LogoColumn() {
  return (
    <Styled.Info>
      <Styled.Logo>
        <img src={LogoImage} alt="moj vik" />
      </Styled.Logo>

      <h2>{l10n.login.infoTitle}</h2>
      <a href="http://mojvik.kdvik-rijeka.hr/">{l10n.login.infoLink}</a>

      <br />
      <br />

      <h3>Zašto aktivirati uslugu?</h3>
      <h3>- zaprimanje obavijesti o uvećanoj potrošnji na adresu e-pošte</h3>
      <h3>- zaprimanje računa na adresu e-pošte</h3>
      <h3>- uvid u račune unatrag tri godine</h3>
      <h3>- uvid u potrošnju, plaćanja i dugovanja</h3>
      <br />
      <a
        href="https://www.kdvik-rijeka.hr/novosti/188/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Saznajte više o e-usluzi Moj ViK
      </a>
    </Styled.Info>
  )
}

export default LogoColumn
